@use '@fpsm/cxy-scss' as cxy;

.container {
  @include cxy.stack(var(--cxy-spacing-4));
}

.rangeSliderFilter {
  margin-top: var(--cxy-spacing-4);
}

.resetButton {
  align-self: center;
}
